import { render, staticRenderFns } from "./PrivateFeedbackForm.vue?vue&type=template&id=2ca633a8&scoped=true"
import script from "./PrivateFeedbackForm.vue?vue&type=script&lang=js"
export * from "./PrivateFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./PrivateFeedbackForm.vue?vue&type=style&index=0&id=2ca633a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca633a8",
  null
  
)

export default component.exports